const TAG_WHITELIST = {
  bold: 'b',
  newLine: 'br/',
  list: 'ul',
  listItem: 'li',
};

const ALLOWED_HTML_TAGS = new Set(
  Object.values(TAG_WHITELIST).map(tag => tag.replace('/', '')),
);

export const formatNarrative = text => {
  if (!text) return '';

  let formattedText = text;

  Object.entries(TAG_WHITELIST).forEach(([customTag, htmlTag]) => {
    if (htmlTag.includes('/')) {
      formattedText = formattedText.replace(
        new RegExp(`<${customTag}>`, 'g'),
        `<${htmlTag}>`,
      );
    } else {
      formattedText = formattedText.replace(
        new RegExp(`<${customTag}>`, 'g'),
        `<${htmlTag}>`,
      );

      formattedText = formattedText.replace(
        new RegExp(`</${customTag}>`, 'g'),
        `</${htmlTag}>`,
      );
    }
  });

  formattedText = formattedText.replace(
    /<\/?([^>\s]+)[^>]*>/g,
    (match, tagName) => {
      tagName = tagName.split(' ')[0];
      tagName = tagName.replace('/', '');

      return ALLOWED_HTML_TAGS.has(tagName) ? match : '';
    },
  );

  formattedText = formattedText.replace(
    /<b>(.*?)<\/b>/g,
    '<b><span style="">$1</span></b>',
  );

  formattedText = formattedText.replace(
    /(<\/b>|<br\/>)([^<]+)/g,
    (match, tag, content) => `${tag}<span style="">${content}</span>`,
  );

  return formattedText;
};
